import { signInClicked } from "../lib/auth.ts";
import { Button, Card } from "../ui/index.ts";

/** Only reached after a deliberate sign-out, or when silent login could not
 *  complete — a signed-in operator goes straight through. */
export function SignIn() {
	return (
		<main className="grid min-h-dvh place-items-center p-6">
			<Card className="w-full max-w-md p-8">
				<p className="text-xs font-bold uppercase tracking-[0.16em] text-muted">G1 Network</p>
				<h1 className="mt-3 text-2xl font-bold text-content">X Ads</h1>
				<p className="mt-2 mb-6 text-sm text-muted">
					Buying console for the group's X (Twitter) ad accounts. Sign in to see the accounts you
					control — or create an account and register your team, and we will review it.
				</p>
				<Button onClick={() => void signInClicked()}>Sign in or create an account</Button>
			</Card>
		</main>
	);
}
